// frontend/src/constants/productConstants.js
export const PRODUCT_LIST_REQUEST = 'PRODUCT_LIST_REQUEST';
export const PRODUCT_LIST_SUCCESS = 'PRODUCT_LIST_SUCCESS';
export const PRODUCT_LIST_FAIL = 'PRODUCT_LIST_FAIL';


export const PRODUCT_DETAILS_SUCCESS = 'PRODUCT_LIST_SUCCESS';
export const PRODUCT_DETAILS_FAIL = 'PRODUCT_LIST_FAIL';

export const PRODUCT_CREATE_REQUEST = 'PRODUCT_CREATE_REQUEST';
export const PRODUCT_CREATE_SUCCESS = 'PRODUCT_CREATE_SUCCESS';
export const PRODUCT_CREATE_FAIL = 'PRODUCT_CREATE_FAIL';

export const PRODUCT_UPDATE_REQUEST = 'PRODUCT_UPDATE_REQUEST';
export const PRODUCT_UPDATE_SUCCESS = 'PRODUCT_UPDATE_SUCCESS';
export const PRODUCT_UPDATE_FAIL = 'PRODUCT_UPDATE_FAIL';

export const PRODUCT_DELETE_REQUEST = 'PRODUCT_DELETE_REQUEST';
export const PRODUCT_DELETE_SUCCESS = 'PRODUCT_DELETE_SUCCESS';
export const PRODUCT_DELETE_FAIL = 'PRODUCT_DELETE_FAIL';


export const PRODUCT_SUSPEND_REQUEST = 'PRODUCT_SUSPEND_REQUEST';
export const PRODUCT_SUSPEND_FAIL = 'PRODUCT_SUSPEND_FAIL';
export const PRODUCT_SUSPEND_SUCCESS = 'PRODUCT_SUSPEND_SUCCESS';




